import React from "react";
import { Box, Grommet, Text } from "grommet";
import { theme } from "./design-system";
import Amplify from "aws-amplify";
import { Authenticator, useTheme } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { ReactComponent as Logo } from "./assets/umc-utrecht-logo.svg";
import awsconfig from "./aws-exports";
import { AuthenticatedApp } from "./screens/authenticated-app";
import { LoginText } from "./task-specific/content/descriptions";

Amplify.configure(awsconfig);

function Header() {
  return (
    <Box align="center" pad="medium">
      <Logo width="150" height="80" />
    </Box>
  );
}

function Footer() {
  return (
    <Box align="center" pad="medium">
      <Text color="grey" textAlign="center">
        <LoginText />
      </Text>
    </Box>
  );
}

function SignUpHeader() {
  const { tokens } = useTheme();

  return (
    <Box pad={`${tokens.space.xl} ${tokens.space.xl} 0`}>
      <Text size="medium">
        For this tool to work, you need to create an account. This is only to prevent misuse and we won't use your account or email for
        anything. If you have already created an account, you can <strong>Sign In</strong>.
      </Text>
    </Box>
  );
}

export default function App(): React.ReactElement {
  return (
    <Grommet theme={theme} full={true}>
      <Box align="center" justify="center" fill>
        <Authenticator
          initialState="signUp"
          loginMechanisms={["email"]}
          components={{
            Header,
            SignUp: {
              Header: SignUpHeader,
            },
            Footer,
          }}
        >
          {({ signOut }) => <AuthenticatedApp signOut={signOut} />}
        </Authenticator>
      </Box>
    </Grommet>
  );
}
